module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1 pa-2",
    attrs: {
      "color": _vm.actividad.oculto ? 'secondary primary--text' : '',
      "dark": _vm.actividad.oculto === 1,
      "max-width": "500"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "450",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalEliminarActividad()
      }
    },
    model: {
      value: (_vm.isModalEliminarActividad),
      callback: function($$v) {
        _vm.isModalEliminarActividad = $$v
      },
      expression: "isModalEliminarActividad"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-20 py-4"
  }, [_vm._v("¿Estas seguro que deseas eliminar esta actividad?")]), _c('div', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    ref: "comentarioParaEliminarActividad",
    attrs: {
      "hide-details": "hide-details",
      "autofocus": "autofocus",
      "placeholder": "Describe un motivo por el cual deseas eliminar la actividad",
      "color": "primary",
      "solo": "solo",
      "dense": "dense",
      "rows": "6"
    },
    model: {
      value: (_vm.comentarioParaEliminarActividad),
      callback: function($$v) {
        _vm.comentarioParaEliminarActividad = $$v
      },
      expression: "comentarioParaEliminarActividad"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.closeModalEliminarActividad()
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchEliminarActividad()
      }
    }
  }, [_vm._v("Eliminar actividad")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "transition": "dialog-bottom-transition",
      "fullscreen": true
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeDialogImage()
      }
    },
    model: {
      value: (_vm.showImageFull),
      callback: function($$v) {
        _vm.showImageFull = $$v
      },
      expression: "showImageFull"
    }
  }, [(_vm.imagePreview) ? _c('v-card', {
    staticClass: "overflow-hidden"
  }, [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "height": _vm.isMovil ? ("calc(100vh - " + (!_vm.imagePreview.group ? '225px' : '170px') + ")") : ("calc(100vh - " + (!_vm.imagePreview.group ? '160px' : '100px') + ")")
    }
  }, [_c('v-img', {
    staticClass: "background-filter position-relative",
    style: (("-webkit-transform: rotate(" + _vm.rotateDeg + "deg);")),
    attrs: {
      "src": _vm.imagePreview.contenido
    }
  }), _c('div', {
    staticClass: "box-preview-image d-flex jc-center ai-center"
  }, [_c('v-img', {
    staticClass: "text-end",
    style: (("-webkit-transform: rotate(" + _vm.rotateDeg + "deg);")),
    attrs: {
      "src": _vm.imagePreview.contenido,
      "height": _vm.isMovil ? 400 : 780,
      "contain": "contain"
    }
  }), _c('div', {
    staticClass: "d-flex rotates ai-center jc-center"
  }, [_c('div', {
    staticClass: "ma-1 ml-8"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "fab": ""
    },
    on: {
      "click": _vm.rotateImage
    }
  }, [_c('v-icon', [_vm._v("rotate_90_degrees_ccw")])], 1), _c('small', {
    staticClass: "font-weight-700 ml-2"
  }, [_vm._v(_vm._s(_vm.rotateDeg) + "°")])], 1), _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(!_vm.actividad.oculto && _vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario' && _vm.actividad.origen === 'empresa') ? _c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-4",
          attrs: {
            "icon": "icon",
            "small": "small"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("more_vert")])], 1) : _vm._e()]
      }
    }], null, false, 2840589149)
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openModalEliminarActividad()
      }
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "grey lighten-1",
    attrs: {
      "dark": "",
      "size": "20"
    }
  }, [_vm._v("delete_sweep")])], 1), _c('v-list-item-title', [_vm._v("Eliminar esta actividad")])], 1)], 1)], 1)], 1), (!_vm.isMovil) ? _c('div', {
    staticClass: "d-flex return"
  }, [_c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "dark": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogImage()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1)], 1) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [_c('v-slide-group', {
    attrs: {
      "active-class": "success",
      "show-arrows": ""
    }
  }, _vm._l((_vm.isGroupImagenes), function(n, index) {
    return _c('v-slide-item', {
      key: index,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "ma-1",
            class: {
              'border': _vm.indexGroupItem === index
            },
            attrs: {
              "hover": "hover"
            },
            on: {
              "click": function($event) {
                return _vm.seleccionarImagen(index)
              }
            }
          }, [_c('v-img', {
            attrs: {
              "src": n.contenido,
              "height": "55",
              "width": "55",
              "contain": "contain"
            }
          })], 1)]
        }
      }], null, true)
    })
  }), 1)], 1), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-avatar', [_c('avatar-perfil', {
    attrs: {
      "is-fetch": true,
      "usuario": _vm.imagePreview.usuario
    }
  })], 1)], 1), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-700",
    domProps: {
      "textContent": _vm._s(_vm.imagePreview.nombre)
    }
  }), _c('v-list-item-subtitle', {
    staticClass: "font-size-12",
    domProps: {
      "textContent": _vm._s(_vm.imagePreview.fechaLegible)
    }
  })], 1), _c('v-list-item-action', [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "color": "primary",
      "href": _vm.imagePreview.contenido,
      "target": "_blanck",
      "small": "small"
    }
  }, [_c('v-icon', [_vm._v("fullscreen")])], 1), _c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "fab": "fab",
      "color": "success white--text",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.descargarImagen(_vm.imagePreview.contenido, _vm.imagePreview.nombreAdjunto)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_downward")])], 1)], 1)])], 1)], 1), (_vm.isMovil) ? _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogImage()
      }
    }
  }, [_vm._v("cerrar")])], 1) : _vm._e()], 1) : _vm._e()], 1), (!_vm.actividad.oculto) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "fd-column d-flex"
  }, [_c('small', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v(" " + _vm._s(_vm.actividad.nombre))]), _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(" " + _vm._s(_vm.actividad.cargo))])]), _c('v-spacer'), _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(!_vm.actividad.group && !_vm.actividad.oculto && _vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario' && _vm.actividad.origen === 'empresa') ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "icon",
            "color": "grey",
            "small": "small"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("more_vert")])], 1) : _vm._e()]
      }
    }], null, false, 2665882338)
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openModalEliminarActividad()
      }
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "grey lighten-1",
    attrs: {
      "dark": "",
      "size": "20"
    }
  }, [_vm._v("delete_sweep")])], 1), _c('v-list-item-title', [_vm._v("Eliminar esta actividad")])], 1)], 1)], 1)], 1) : _vm._e(), _c('div', [(_vm.actividad.oculto) ? _c('div', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": "18"
    }
  }, [_vm._v("do_not_disturb")]), _c('span', {
    staticClass: "font-size-11 font-italic"
  }, [_vm._v("  Esta actividad fue eliminada :  "), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("\"" + _vm._s(_vm.actividad.mensajeOculto) + "\"")])])], 1) : _c('div', [(_vm.actividad.tipo === 'adjunto') ? [_c('span', {
    staticClass: "font-size-11 grey--text"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.actividad.accion)))]), (_vm.actividad.tipoAdjunto === 'image/png' || _vm.actividad.tipoAdjunto === 'image/jpg' || _vm.actividad.tipoAdjunto === 'image/jpeg') ? _c('div', [(!_vm.actividad.group) ? _c('v-card', {
    staticClass: "mt-1 elevation-1",
    attrs: {
      "max-height": "230"
    },
    on: {
      "click": function($event) {
        return _vm.showDialogImage(false, 0, _vm.actividad)
      }
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85",
      "src": _vm.actividad.contenido,
      "max-height": "150",
      "content": "content"
    }
  }, [_c('v-btn', {
    staticClass: "position-get",
    attrs: {
      "fab": "fab",
      "color": "success white--text",
      "x-small": "x-small"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.descargarImagen(_vm.imagePreview.contenido, _vm.imagePreview.nombreAdjunto)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_downward")])], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "px-4 py-2 font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.nombreAdjunto))])], 1)], 1)], 1) : _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-row', {
    attrs: {
      "dense": "dense"
    }
  }, [(_vm.actividad.render1) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": function($event) {
        return _vm.showDialogImage(true, 0, _vm.actividad.imagenes)
      }
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85",
      "src": _vm.actividad.imagenes[0].contenido,
      "max-height": "150",
      "height": "110",
      "content": "content"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "px-2 py-2 font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.imagenes[0].nombreAdjunto))])], 1)])], 1)], 1) : _vm._e(), (_vm.actividad.render2) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": function($event) {
        return _vm.showDialogImage(true, 1, _vm.actividad.imagenes)
      }
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85",
      "src": _vm.actividad.imagenes[1].contenido,
      "max-height": "150",
      "height": "110",
      "content": "content"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "px-2 py-2 font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.imagenes[1].nombreAdjunto))])], 1)])], 1)], 1) : _vm._e(), (_vm.actividad.render3) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": function($event) {
        return _vm.showDialogImage(true, 2, _vm.actividad.imagenes)
      }
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85",
      "src": _vm.actividad.imagenes[2].contenido,
      "max-height": "150",
      "height": "110",
      "content": "content"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "px-2 py-2 font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.imagenes[2].nombreAdjunto))])], 1)])], 1)], 1) : _vm._e(), (_vm.actividad.render4) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    on: {
      "click": function($event) {
        return _vm.showDialogImage(true, 3, _vm.actividad.imagenes)
      }
    }
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": _vm.actividad.countMore ? 'to bottom, #000000a8, #161f2b' : 'to bottom, rgba(0,0,0,.1),#161f2b85',
      "src": _vm.actividad.imagenes[3].contenido,
      "max-height": "150",
      "height": "110",
      "content": "content"
    }
  }, [_c('div', {
    staticClass: "d-flex",
    class: {
      '': _vm.actividad.countMore
    }
  }, [(!_vm.actividad.countMore) ? _c('v-spacer') : _vm._e(), (_vm.actividad.countMore) ? _c('div', {
    staticClass: "px-4 py-4"
  }, [_c('span', {
    staticClass: "font-size-30 font-weight-700"
  }, [_vm._v("+ " + _vm._s(_vm.actividad.countMore))])]) : _c('small', {
    staticClass: "px-4 py-2 font-size-11 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.imagenes[3].nombreAdjunto))])], 1)])], 1)], 1) : _vm._e()], 1)], 1)], 1) : (_vm.actividad.tipoAdjunto === 'video/mp4') ? _c('v-card', {
    staticClass: "mt-2 elevation-0",
    attrs: {
      "height": "100%"
    }
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.actividad.contenido,
      "type": "video/mp4"
    }
  })])]) : _c('v-card', {
    staticClass: "mt-1 elevation-0"
  }, [_c('v-divider', {
    staticClass: "pa-0 ma-0"
  }), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "two-line": "",
      "dense": "dense",
      "color": _vm.actividad.origen !== 'empresa' ? '' : ''
    }
  }, [_c('v-list-item', {
    staticClass: "px-2",
    on: {
      "click": function () {}
    }
  }, [_c('v-list-item-action', {
    staticClass: "mr-3"
  }, [(_vm.actividad.tipoAdjunto === 'application/pdf') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/pdf.png"),
      "width": "45"
    }
  }) : (_vm.actividad.tipoAdjunto === 'text/plain') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/txt.png"),
      "width": "45"
    }
  }) : (_vm.actividad.tipoAdjunto === 'application/x-msdownload') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/exe.png"),
      "width": "45"
    }
  }) : (_vm.actividad.tipoAdjunto === 'application/x-zip-compressed') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/zip.png"),
      "width": "45"
    }
  }) : (_vm.actividad.tipoAdjunto === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/xls.png"),
      "width": "45"
    }
  }) : (_vm.actividad.tipoAdjunto === 'application/msword' || _vm.actividad.tipoAdjunto === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') ? _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/doc.png"),
      "width": "45"
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../static/img/icons-actividad/search.png"),
      "width": "45"
    }
  })]), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-size-12",
    domProps: {
      "textContent": _vm._s(_vm.actividad.nombreAdjunto)
    }
  }), _c('v-list-item-subtitle', {
    staticClass: "font-size-11",
    domProps: {
      "textContent": _vm._s(_vm.actividad.tipoAdjunto)
    }
  })], 1), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "x-small": "x-small",
      "color": "success",
      "href": _vm.actividad.contenido,
      "target": "_blanck"
    }
  }, [_c('v-icon', [_vm._v("arrow_downward")])], 1)], 1)], 1)], 1)], 1)] : _vm._e(), (_vm.actividad.tipo === 'cambio') ? [_c('span', {
    staticClass: "font-size-11 grey--text"
  }, [_vm._v(_vm._s(_vm.actividad.accion))]), (_vm.actividad.comentario) ? _c('v-card', {
    staticClass: "pa-3 elevation-0",
    attrs: {
      "color": "#fb8c0021"
    }
  }, [_c('div', {
    staticClass: "font-size-11 font-italic warning--text"
  }, [_vm._v(_vm._s(("\"" + (_vm.actividad.comentario) + "\"")))])]) : _vm._e(), _vm._l((JSON.parse(_vm.actividad.contenido)), function(a, e, i) {
    return _c('div', [_c('v-list-item', {
      staticClass: "px-0"
    }, [_c('v-list-item-content', {
      staticClass: "py-1"
    }, [_c('v-list-item-title', {
      staticClass: "font-size-12 font-weight-700"
    }, [_vm._v(_vm._s(_vm._f("capitalize")(e)))]), _c('div', {
      staticClass: "font-size-11 font-weight-700 white-space-none"
    }, [_c('div', {
      staticClass: "d-flex",
      class: {
        'fd-column': _vm.isMovil, 'jc-center ai-center': !_vm.isMovil
      }
    }, [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(a[0]))]), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), (!_vm.isMovil) ? _c('v-icon', {
      staticClass: "px-2",
      attrs: {
        "color": "background",
        "size": "18"
      }
    }, [_vm._v("east")]) : _vm._e(), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), _c('span', {
      staticClass: "success--text"
    }, [_vm._v(" " + _vm._s(a[1]))])], 1)])], 1)], 1), (i < Object.keys(JSON.parse(_vm.actividad.contenido)).length - 1) ? _c('v-divider', {
      staticClass: "pa-0 ma-0"
    }) : _vm._e()], 1)
  })] : _vm._e(), (_vm.actividad.tipo === 'cita') ? [_c('span', {
    staticClass: "font-size-11 grey--text"
  }, [_vm._v(_vm._s(_vm.actividad.accion))]), _c('v-card', {
    staticClass: "elevation-1"
  }, [_vm._l((JSON.parse(_vm.actividad.contenido)), function(a, e, i) {
    return _c('div', [_c('v-list-item', {
      staticClass: "px-0"
    }, [_c('v-list-item-content', {
      staticClass: "py-1"
    }, [_c('v-list-item-title', {
      staticClass: "font-size-12 font-weight-700"
    }, [_vm._v(_vm._s(_vm._f("capitalize")(e)))]), _c('div', {
      staticClass: "font-size-11 font-weight-700 white-space-none"
    }, [_c('div', {
      staticClass: "d-flex",
      class: {
        'fd-column': _vm.isMovil, 'jc-center ai-center': !_vm.isMovil
      }
    }, [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(a[0]))]), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), (!_vm.isMovil) ? _c('v-icon', {
      staticClass: "px-2",
      attrs: {
        "color": "background",
        "size": "18"
      }
    }, [_vm._v("east")]) : _vm._e(), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), _c('span', {
      staticClass: "success--text"
    }, [_vm._v(" " + _vm._s(a[1]))])], 1)])], 1)], 1), (i < Object.keys(JSON.parse(_vm.actividad.contenido)).length - 1) ? _c('v-divider', {
      staticClass: "pa-0 ma-0"
    }) : _vm._e()], 1)
  }), (!_vm.actividad.comentario) ? _c('v-list', {
    staticClass: "py-1",
    attrs: {
      "subheader": "",
      "dense": "dense",
      "color": "background",
      "dark": "dark"
    }
  }, [_c('v-list-item', [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "grey",
      "size": "35"
    }
  }, [_vm._v("insert_invitation")]), _c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "grey--text font-size-11"
  }, [_vm._v("Cita programada para el")]), _c('v-list-item-title', {
    staticClass: "font-size-16 font-weight-700 primary--text"
  }, [_vm._v(_vm._s(_vm.actividad.tipoAdjunto))])], 1), (_vm.isLog) ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "x-small": "x-small",
      "color": "info white--text"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)], 1) : _vm._e(), (!_vm.isLog && _vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario') ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "x-small": "x-small",
      "color": "primary white--text",
      "disabled": _vm.perfilUsuario === 'supervisor'
    },
    on: {
      "click": function($event) {
        return _vm.goTo(("/programacion/citas/" + (_vm.actividad.nombreAdjunto)))
      }
    }
  }, [_c('v-icon', [_vm._v("north_east")])], 1)], 1) : _vm._e()], 1)], 1) : _c('v-list', {
    staticClass: "py-1",
    attrs: {
      "subheader": "",
      "dense": "dense",
      "color": "secondary "
    }
  }, [_c('v-list-item', [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "size": "35"
    }
  }, [_vm._v("event_busy")]), _c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "primary--text font-size-12"
  }, [_vm._v("La cita programada fue cancelada")])], 1), (_vm.isLog) ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "x-small": "x-small",
      "color": "info white--text"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)], 1) : _vm._e()], 1)], 1), (_vm.actividad.comentario) ? _c('v-card', {
    staticClass: "pa-3 elevation-0",
    attrs: {
      "color": "#fb8c0021"
    }
  }, [_c('div', {
    staticClass: "font-size-11 font-italic warning--text"
  }, [_vm._v(_vm._s(("\"" + (_vm.actividad.comentario) + "\"")))])]) : _vm._e(), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_c('v-card-text', {
    staticClass: "py-1 px-2"
  }, _vm._l((JSON.parse(_vm.actividad.contenido)), function(a, e, i) {
    return _c('div', [_c('v-list-item', {
      staticClass: "px-0"
    }, [_c('v-list-item-content', {
      staticClass: "py-1"
    }, [_c('v-list-item-title', {
      staticClass: "font-size-12 font-weight-700"
    }, [_vm._v(_vm._s(_vm._f("capitalize")(e)))]), _c('div', {
      staticClass: "font-size-11 font-weight-700 white-space-none"
    }, [_c('div', {
      staticClass: "d-flex",
      class: {
        'fd-column': _vm.isMovil, 'jc-center ai-center': !_vm.isMovil
      }
    }, [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(a[0]))]), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), (!_vm.isMovil) ? _c('v-icon', {
      staticClass: "px-2",
      attrs: {
        "color": "background",
        "size": "18"
      }
    }, [_vm._v("east")]) : _vm._e(), (!_vm.isMovil) ? _c('v-spacer') : _vm._e(), _c('span', {
      staticClass: "success--text"
    }, [_vm._v(" " + _vm._s(a[1]))])], 1)])], 1)], 1)], 1)
  }), 0)], 1)])], 2)] : _vm._e(), (_vm.actividad.tipo === null || _vm.actividad.tipo === '') ? [_c('span', {
    staticClass: "font-size-11 grey--text"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.actividad.accion)))]), (_vm.actividad.comentario) ? _c('v-card', {
    staticClass: "pa-3 elevation-0",
    attrs: {
      "color": "#fb8c0021"
    }
  }, [_c('div', {
    staticClass: "font-size-11 font-italic warning--text"
  }, _vm._l((_vm.returFormatComentario(_vm.actividad.comentario)), function(m, index) {
    return _c('span', [(m) ? _c('span', [_vm._v(_vm._s(m)), _c('br')]) : _vm._e()])
  }), 0)]) : _vm._e()] : _vm._e(), (_vm.isMovil) ? _c('div', {
    staticClass: "d-flex mt-1"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.actividad.fechaLegible))])], 1) : _vm._e()], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dd831be","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_item_timeline.vue
// module id = 493
// module chunks = 1